import React from "react";

const Workflow = () => {
  const steps = [
    { name: "Extract", icon: "📥" },
    { name: "Transform", icon: "🔧" },
    { name: "Load", icon: "📤" },
    { name: "Automate", icon: "⚙️" },
    { name: "Visualize", icon: "📊" },
  ];

  return (
    <section id="workflow" className="py-16 bg-gray-100 dark:bg-gray-800">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-gray-100">
          Data Engineering Workflow
        </h2>
        <div className="flex flex-col md:flex-row justify-center items-center gap-6">
          {steps.map((step, i) => (
            <div
              key={i}
              className="bg-gray-300 dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-lg shadow p-6 flex flex-col items-center w-40 transition hover:scale-105"
            >
              <span className="text-3xl mb-2">{step.icon}</span>
              <span className="font-semibold">{step.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Workflow;